import { CategoryWithFaqs } from '../../../types'

export const styleToIcon: Record<CategoryWithFaqs['icon']['title'], { [key: string]: string }> = {
  Returns: {
    transform: 'translateX(2px)',
  },
  Locker: {
    transform: 'translateX(2px)',
  },
  Delivery: {
    transform: 'translateX(2px)',
  },
  Heart: {
    transform: 'translateX(-2px)',
  },
}
